import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { Link, NavLink, Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Navbar, Nav, Offcanvas, Button } from "react-bootstrap";
import {
  FaDice,
  FaHorse,
  FaHorseHead,
  FaRegEye,
  FaRocket,
  FaTrophy,
  FaUser,
} from "react-icons/fa";
import { BiCricketBall, BiFootball, BiSolidTennisBall } from "react-icons/bi";
import { ImSpades } from "react-icons/im";
import { PiMonitorPlay } from "react-icons/pi";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css";
import "../../../src/App.css";
import LoginPopup from "../LoginPopup/LoginPopup";
import AccountStatus from "../AccountStatus/AccountStatus";
import { useNavigate } from "react-router-dom";
// import Helper from "../../helper";
import { useAuth } from "../AuthContext";
import Appconfig from "../../config/config";
import axios from "axios";
import { getOpenBets as fetchOpenBetsApi } from "../../services/users";
import { useDispatch, useSelector } from "react-redux";
import { emptyUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import SignUp from "../SignUp/SignUp";
import Login from "../Login/Login";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { toast } from "react-toastify";
import UserAutoLogout from "../userAutoLogout";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import MyMarketPopup from "../MyMarketPopup/MyMarketPopup";
import ScrollGames from "../ScrollGames/ScrollGames";
import SideMenu from "../SideMenu/SideMenu";
import RightMenu from "../RightMenu/RightMenu";
import { getAllEvents } from "../../redux/slice/event/eventSlice";
import RulesModal from "../Rules/Rules";

const DESKTOP_NAV_ITEMS = [
  { id: "cricket", label: "CRICKET", eventType: 4 },
  { id: "football", label: "FOOTBALL", eventType: 1 },
  { id: "tennis", label: "TENNIS", eventType: 2 },
  { id: "fantasy-11", label: "FANTASY 11", openLogin: true },
  { id: "cock-fight", label: "COCK FIGHT", openLogin: true },
  { id: "politics", label: "POLITICS", openLogin: true },
  { id: "casino", label: "CASINO", openLogin: true },
  { id: "sports-book", label: "SPORTS BOOK", openLogin: true },
  { id: "horse-racing", label: "HORSE RACING", openLogin: true },
  { id: "greyhound-racing", label: "GREYHOUND RACING", openLogin: true },
  { id: "other", label: "OTHER", openLogin: true },
  { id: "binary", label: "BINARY", openLogin: true },
  { id: "kabaddi", label: "KABADDI", openLogin: true },
  { id: "basketball", label: "BASKETBALL", openLogin: true },
  { id: "baseball", label: "BASEBALL", openLogin: true },
  { id: "table-tennis", label: "TABLE TENNIS", openLogin: true },
  { id: "volleyball", label: "VOLLEYBALL", openLogin: true },
  { id: "ice-hockey", label: "ICE HOCKEY", openLogin: true },
  { id: "rugby", label: "RUGBY", openLogin: true },
  { id: "mixed-martial-arts", label: "MIXED MARTIAL ARTS", openLogin: true },
  { id: "darts", label: "DARTS", openLogin: true },
  { id: "futsal", label: "FUTSAL", openLogin: true },
  { id: "genius", label: "GENIUS", openLogin: true },
];

// Desktop green navigation kin pages par show hogi
const DESKTOP_NAV_VISIBLE_ROUTES = [
  "/",
  "/home",
  "/dashboard",
  "/all-games-lobby",
  "/matchupdates",
  "/accountstatement",
  "/account-statement",
  "/deposit",
  "/withdraw",
  "/add-withdraw-method",
];

// Live matches kin pages par show honge
const LIVE_MATCHES_VISIBLE_ROUTES = ["/", "/home", "/dashboard"];

const isRouteVisible = (currentPath, visibleRoutes) => {
  return visibleRoutes.some((route) => {
    // Root route sirf exact "/" par match honi chahiye
    if (route === "/") {
      return currentPath === "/";
    }

    // Static aur dynamic child routes dono match honge
    return currentPath === route || currentPath.startsWith(`${route}/`);
  });
};

const Header = ({
  showMenu,
  openSideMenu,
  closeSideMenu,
  handleToggleMenu,
  isMobile,
  whatsappNum,
  setEventType,
}) => {
  // const navigate = useNavigate();
  // const userInfo = Helper();
  // const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath =
    location.pathname.replace(/\/+$/, "").toLowerCase() || "/";

  const showDesktopNavigation = isRouteVisible(
    currentPath,
    DESKTOP_NAV_VISIBLE_ROUTES,
  );

  const showLiveMatches = isRouteVisible(
    currentPath,
    LIVE_MATCHES_VISIBLE_ROUTES,
  );

  const { user, isAuthenticated, logout } = useAuth();

  const userInfo = isAuthenticated && user ? user : null;
  const betData = useSelector((state) => state.data); // Use selector to access state
  const eventStore = useSelector((state) => state.events);
  const dispatch = useDispatch();
  UserAutoLogout();
  const [showOffcanvas, setShowOffcanvas] = useState(false); // Right slider
  const [showAccountMenu, setShowAccountMenu] = useState(false);

  const [showHeaderBalance, setShowHeaderBalance] = useState(() => {
    return localStorage.getItem("showHeaderBalance") !== "false";
  });

  const [showHeaderExposure, setShowHeaderExposure] = useState(() => {
    return localStorage.getItem("showHeaderExposure") !== "false";
  });

  const accountMenuRef = useRef(null);
  // const [showMenu, setShowMenu] = useState(false); // Left slider
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const [showMyMarkets, setShowMyMarkets] = useState(false);

  const [myMarketRows, setMyMarketRows] = useState([]);

  const [myMarketLoading, setMyMarketLoading] = useState(false);

  const openMyMarketsPopup = useCallback((event) => {
    /*
     * Exposure parent account button ke andar hai,
     * isliye account menu click ko stop karo.
     */
    event?.preventDefault();
    event?.stopPropagation();

    setShowAccountMenu(false);
    setShowMyMarkets(true);
  }, []);

  const closeMyMarketsPopup = useCallback(() => {
    setShowMyMarkets(false);
  }, []);

  const getEventTypeName = useCallback((eventType, fallbackName) => {
    const normalizedType = Number(eventType);

    const eventTypeNames = {
      1: "Football",
      2: "Tennis",
      4: "Cricket",
      7: "Horse Racing",
      4339: "Greyhound Racing",
    };

    return eventTypeNames[normalizedType] || fallbackName || "Sports";
  }, []);

  const loadMyMarkets = useCallback(async () => {
    const userId = userInfo?._id;

    if (!userId) {
      setMyMarketRows([]);
      return;
    }

    setMyMarketLoading(true);

    try {
      const response = await fetchOpenBetsApi({
        user_id: userId,
        request_time: Date.now(),
      });

      const apiBets =
        response?.data?.result && Array.isArray(response?.data?.resultData)
          ? response.data.resultData
          : [];

      /*
       * Same event + same market ki multiple bets
       * ko ek row me group karo.
       */
      const groupedMarkets = new Map();

      apiBets.forEach((bet) => {
        const status = String(bet?.status || "Open").toLowerCase();

        const isDeleted =
          String(bet?.is_delete || "No").toLowerCase() === "yes";

        const isCancelled =
          String(bet?.is_cancel || "No").toLowerCase() === "yes";

        if (
          status === "settled" ||
          status === "cashedout" ||
          isDeleted ||
          isCancelled
        ) {
          return;
        }

        const matchId = String(bet?.match_id ?? bet?.event_id ?? "");

        const marketId = String(bet?.market_id ?? "");

        const groupKey = [matchId, marketId, bet?.market_name || ""].join("_");

        const existingRow = groupedMarkets.get(groupKey);

        if (existingRow) {
          existingRow.tradeCount += 1;
          return;
        }

        const competitionName =
          bet?.competition_name ||
          bet?.competition ||
          bet?.series_name ||
          bet?.seriesName ||
          bet?.event_name ||
          "Sports Market";

        const matchName =
          bet?.match_name ||
          bet?.event_name ||
          bet?.market_name ||
          bet?.runner_name ||
          "Open Market";

        groupedMarkets.set(groupKey, {
          id: groupKey || bet?._id || bet?.betting_id,

          eventType: getEventTypeName(bet?.event_type, bet?.event_type_name),

          eventName: competitionName,

          matchName: matchName,

          tradeCount: 1,

          matchId,
          marketId,

          marketName: bet?.market_name || "",

          isInplay: Boolean(bet?.is_inplay),
        });
      });

      setMyMarketRows(Array.from(groupedMarkets.values()));
    } catch (error) {
      console.error(
        "Unable to load My Markets:",
        error?.response?.data || error?.message || error,
      );

      setMyMarketRows([]);

      toast.error("Unable to load My Markets.");
    } finally {
      setMyMarketLoading(false);
    }
  }, [userInfo?._id, getEventTypeName]);

  useEffect(() => {
    if (!showMyMarkets) {
      return;
    }

    loadMyMarkets();
  }, [showMyMarkets, loadMyMarkets, betData]);

  const handleSelectMyMarket = useCallback(
    (row) => {
      const matchId = row?.matchId;

      if (!matchId) {
        toast.error("Match ID is missing.");
        return;
      }

      closeMyMarketsPopup();

      const matchStatus = row?.isInplay ? "Inplay" : "Upcoming";

      navigate(`/matchupdates/${matchId}/${matchStatus}`);
    },
    [navigate, closeMyMarketsPopup],
  );

  const [showCricketList, setShowCricketList] = useState(false);
  const [showFootballList, setShowFootballList] = useState(false);
  const [showTennisList, setShowTennisList] = useState(false);
  const [showHorseRacingList, setShowHorseRacingList] = useState(false);
  const [showGrayHoundRacingList, setShowGrayHoundRacingList] = useState(false);
  const [showIndianCardGamesList, setShowIndianCardGamesList] = useState(false);
  const [showLoginModel, setShowLoginModel] = useState(false);
  const [showSignupModel, setShowSignupModel] = useState(false);
  const [showForgotModel, setShowForgotModel] = useState(false);
  // const [whatsappNum, setWhatsAppNumber] = useState("");
  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);

  const balanceRequestInFlightRef = useRef(false);

  const balanceWithExp = useMemo(() => {
    return (Number(balance) || 0) - Math.abs(Number(exposure) || 0);
  }, [balance, exposure]);
  const [headerLiveMatches, setHeaderLiveMatches] = useState([]);

  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      // Format date as "Jul 1st, 2025"
      const day = now.getDate();
      const daySuffix = (d) => {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };
      const month = now.toLocaleString("default", { month: "short" });
      const year = now.getFullYear();
      setCurrentDate(
        `${month} ${day}${daySuffix(day)}, ${year} ( GMT +5.5:30 )`,
      );

      // Format time as HH:mm:ss
      setCurrentTime(now.toLocaleTimeString("en-GB", { hour12: false }));
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchHeaderEvents = () => {
      dispatch(
        getAllEvents({
          user_id: userInfo?._id || "",
        }),
      );
    };

    // Header mount hote hi events fetch honge.
    fetchHeaderEvents();

    /*
     * Live matches refresh karne ke liye har
     * 15 seconds mein list update hogi.
     */
    const intervalId = window.setInterval(fetchHeaderEvents, 15000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [dispatch, userInfo?._id]);

  const [showRulesModal, setShowRulesModal] = useState(false);

  const openRulesModal = useCallback(() => {
    setShowAccountMenu(false);
    setShowRulesModal(true);
  }, []);

  const closeRulesModal = useCallback(() => {
    setShowRulesModal(false);
  }, []);

  const freshHeaderLiveMatches = useMemo(() => {
    const eventGroups = Array.isArray(eventStore?.events)
      ? eventStore.events
      : [];

    /*
     * Store structure:
     * events → competitions → events
     */
    const allEvents = eventGroups
      .flatMap((eventGroup) => eventGroup?.competitions || [])
      .flatMap((competition) => competition?.events || []);

    const uniqueEvents = Array.from(
      new Map(
        allEvents.map((event) => [
          String(event?.event_id || event?.eventId || event?._id),
          event,
        ]),
      ).values(),
    );

    const isLiveEvent = (event) => {
      const inPlayValue =
        event?.is_inplay ?? event?.isInplay ?? event?.isInPlay;

      return (
        inPlayValue === true ||
        inPlayValue === 1 ||
        inPlayValue === "1" ||
        String(inPlayValue).toLowerCase() === "true"
      );
    };

    const getEventType = (event) =>
      String(
        event?.event_type ?? event?.eventType ?? event?.event_type_id ?? "",
      );

    const liveEvents = uniqueEvents.filter(isLiveEvent);

    /*
     * Event types from your MatchUpdates code:
     * 4 = Cricket
     * 2 = Tennis
     * 1 = Football
     */
    const cricketMatches = liveEvents
      .filter((event) => getEventType(event) === "4")
      .slice(0, 2)
      .map((event) => ({
        ...event,
        tickerSport: "cricket",
      }));

    const tennisMatches = liveEvents
      .filter((event) => getEventType(event) === "2")
      .slice(0, 2)
      .map((event) => ({
        ...event,
        tickerSport: "tennis",
      }));

    const footballMatches = liveEvents
      .filter((event) => getEventType(event) === "1")
      .slice(0, 2)
      .map((event) => ({
        ...event,
        tickerSport: "football",
      }));

    return [...cricketMatches, ...tennisMatches, ...footballMatches];
  }, [eventStore?.events]);

  useEffect(() => {
    /*
     * Redux refetch ke samay list temporarily
     * empty ho toh existing matches clear
     * nahi honge.
     */
    if (freshHeaderLiveMatches.length === 0) {
      return;
    }

    setHeaderLiveMatches(freshHeaderLiveMatches);
  }, [freshHeaderLiveMatches]);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 991);
  //     if (window.innerWidth > 991) {
  //       setShowMenu(true); // Always show sidebar on desktop
  //     } else {
  //       setShowMenu(false); // Hide sidebar on mobile
  //     }
  //   };
  //   window.addEventListener("resize", handleResize);
  //   handleResize();
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  useEffect(() => {
    console.log("userInfo", userInfo);
  }, [userInfo]);

  const getBalance = useCallback(async () => {
    const userId = userInfo?._id;

    if (!userId || balanceRequestInFlightRef.current) {
      return;
    }

    balanceRequestInFlightRef.current = true;

    try {
      const response = await axios.post(
        `${Appconfig.apiUrl}ledger/getUserBalance`,
        {
          user_id: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const responseData = response?.data;

      if (responseData?.result === 0 || responseData?.result === false) {
        return;
      }

      const resultData = responseData?.resultData || {};

      const updatedBalance = Number(resultData?.balance);
      const updatedExposure = Number(resultData?.exposure);

      if (Number.isFinite(updatedBalance)) {
        setBalance(updatedBalance);
      }

      if (Number.isFinite(updatedExposure)) {
        setExposure(updatedExposure);
      }
    } catch (error) {
      console.error(
        "Unable to refresh user balance:",
        error?.response?.data || error?.message || error,
      );
    } finally {
      balanceRequestInFlightRef.current = false;
    }
  }, [userInfo?._id]);

  useEffect(() => {
    if (!userInfo?._id) {
      setBalance(0);
      setExposure(0);
      return undefined;
    }

    // Header mount hote hi balance load hoga.
    getBalance();

    // Polling aur browser events ke liye common function.
    const refreshBalance = () => {
      if (document.visibilityState === "visible" && navigator.onLine) {
        getBalance();
      }
    };

    // Har 3 seconds latest balance fetch karega.
    const balanceIntervalId = window.setInterval(refreshBalance, 3000);

    // Hidden tab se visible tab par aane par refresh.
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        getBalance();
      }
    };

    // Deposit/Withdraw files se dispatch kiya gaya event.
    const handleCustomBalanceUpdate = () => {
      getBalance();
    };

    // Browser/app par wapas focus aane par.
    window.addEventListener("focus", refreshBalance);

    // Internet reconnect hone par.
    window.addEventListener("online", refreshBalance);

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Custom balance refresh listener.
    window.addEventListener("balance:update", handleCustomBalanceUpdate);

    // Component unmount hone par listeners remove honge.
    return () => {
      window.clearInterval(balanceIntervalId);

      window.removeEventListener("focus", refreshBalance);

      window.removeEventListener("online", refreshBalance);

      document.removeEventListener("visibilitychange", handleVisibilityChange);

      window.removeEventListener("balance:update", handleCustomBalanceUpdate);
    };
  }, [userInfo?._id, getBalance]);

  useEffect(() => {
    if (!userInfo?._id) {
      return;
    }

    getBalance();
  }, [betData, userInfo?._id, getBalance]);

  // const handleLogout = () => {
  //   handleClose();
  //   logout();
  // };

  const handleLogout = () => {
    handleClose();
    closeAccountMenu();
    logout();
    navigate("/login", { replace: true });
  };

  // const handleToggleMenu = () => {
  //   if (showOffcanvas) {
  //     setShowOffcanvas(false); // Close the right slider if it's open
  //   }
  //   setShowMenu(!showMenu);
  // };

  const handleUserClick = () => {
    if (showMenu) {
      handleToggleMenu(); // ✅ Use the prop!
    }
    setShowOffcanvas(true);
  };

  const handleClose = () => {
    setShowOffcanvas(false);
  };

  const toggleAccountMenu = () => {
    closeSideMenu?.();

    setShowAccountMenu((previous) => !previous);
  };

  const closeAccountMenu = () => {
    setShowAccountMenu(false);
  };

  const toggleHeaderBalance = () => {
    setShowHeaderBalance((previous) => {
      const nextValue = !previous;

      localStorage.setItem("showHeaderBalance", String(nextValue));

      return nextValue;
    });
  };

  const toggleHeaderExposure = () => {
    setShowHeaderExposure((previous) => {
      const nextValue = !previous;

      localStorage.setItem("showHeaderExposure", String(nextValue));

      return nextValue;
    });
  };

  const openAccountPage = (path) => {
    closeAccountMenu();
    navigate(path);
  };

  const openDesktopNavigation = (item) => {
    if (item.openLogin) {
      setShowLoginModel(true);
      return;
    }

    // 1. Cricket, football, tennis etc. filter
    if (item.eventType !== undefined) {
      navigate(`/dashboard?sport=${item.eventType}`);
      return;
    }

    // 2. Direct WCO casino launch
    if (item.wcoGame) {
      if (!userInfo?._id) {
        setShowLoginModel(true);
        return;
      }

      const { providerCode, gameCode, type } = item.wcoGame;

      CreateAndLaunchWCOCasino(providerCode, gameCode, type);

      return;
    }

    // 3. Normal page navigation
    if (item.path) {
      navigate(item.path);
    }
  };

  useEffect(() => {
    if (!showAccountMenu) return undefined;

    const handleOutsideClick = (event) => {
      if (
        accountMenuRef.current &&
        !accountMenuRef.current.contains(event.target)
      ) {
        closeAccountMenu();
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        closeAccountMenu();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    document.addEventListener("touchstart", handleOutsideClick);

    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);

      document.removeEventListener("touchstart", handleOutsideClick);

      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [showAccountMenu]);

  const handleLoginPopupClick = () => {
    setShowLoginPopup(true); // Show the login popup
  };

  const handleLoginPopupClose = () => {
    setShowLoginPopup(false); // Hide the login popup
  };

  const handleDeposit = () => {
    setShowDeposit(true);
    navigate("/deposit");
  };
  const handleMyMarkets = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleAviator = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`SPB`, `aviator`);
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleCricketList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleFootballList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleTennisList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleHorseRacingList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleGrayHoundRacingList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  const handleIndianCardGamesList = () => {
    if (userInfo) {
      CreateAndLaunchWCOCasino(`BT`);
    } else {
      // setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  async function CreateAndLaunchWCOCasino(
    providerCode,
    gameCode = "",
    type = null,
  ) {
    if (!userInfo?._id || !userInfo?.user_name) {
      setShowLoginModel(true);
      return;
    }

    try {
      const userData = {
        user_id: userInfo._id,
        user_name: userInfo.user_name,
        redirect_url: window.location.origin,
        provider_code: providerCode,
        game_code: gameCode || "",
        ...(type ? { type } : {}),
      };

      const response = await axios.post(
        `${Appconfig.casinoUrl}wco/login`,
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const status = response.data?.status?.code;
      const message = response.data?.status?.message;
      const launchURL = response.data?.launchURL;

      if (status === "SUCCESS" && launchURL) {
        window.location.assign(launchURL);
        return;
      }

      if (status === "VALIDATION_ERROR" || status === "UNKNOWN_ERROR") {
        toast.error(message || "Game Not Found.", {
          autoClose: 2000,
        });
        return;
      }

      if (status === "AUTHENTICATION_FAILED" || status === "LOGIN_FAILED") {
        toast.error(message || "Casino login failed.", {
          autoClose: 2000,
        });
        return;
      }

      toast.error(message || "Unable to launch game.", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Casino launch error:", error);

      toast.error(
        error.response?.data?.status?.message ||
          "Casino server is not responding.",
        {
          autoClose: 2000,
        },
      );
    }
  }

  function OpenEzugiLobby(casinoType) {
    handleToggleMenu();
    navigate("/all-games-lobby", { state: { activeCasino: casinoType } });
  }

  // const getWhatsAppNumber = () => {
  //   var data = JSON.stringify({
  //     site_code: Appconfig.sitecodes,
  //   });
  //   var config = {
  //     method: "post",
  //     url: `${Appconfig.apiUrl}numbers/getNumberBySiteCode`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };
  //   axios(config)
  //     .then(function (response) {
  //       try {
  //         if (response.data.result) {
  //           setWhatsAppNumber(response.data?.resultData?.mob_num);
  //         }
  //       } catch (e) {
  //         // postErrorToslack(e.message);
  //       }
  //     })
  //     .catch(function (error) {
  //       // postErrorToslack(error.message);
  //       console.log(error);
  //     });
  // };

  const openWhatsApp = (whatsapp) => {
    const url = `https://wa.me/${whatsapp.replace(/\D/g, "")}`;
    window.open(url, "_blank");
  };

  const getHeaderMatchName = (match) => {
    return (
      match?.event_name ||
      match?.eventName ||
      match?.name ||
      match?.match_name ||
      "Live match"
    );
  };

  const getHeaderMatchId = (match) => {
    return match?.event_id || match?.eventId || match?._id;
  };

  const openHeaderLiveMatch = (match) => {
    const matchId = getHeaderMatchId(match);

    if (!matchId) {
      console.error("Live match event ID missing:", match);

      return;
    }

    navigate(`/matchupdates/${matchId}/True`);
  };

  const checkNewLogin = () => {
    var data = JSON.stringify({
      login_token: userInfo.login_token,
      user_id: userInfo._id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}userToken/getToken`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          if (response.data.result) {
          } else {
            localStorage.clear();
            localStorage.removeItem("userdata");
            dispatch(emptyUserInfo());
            localStorage.removeItem("login_token");
            window.location.href = "/";
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        // postErrorToslack(error.message);
        console.log(error);
      });
  };

  // useEffect(() => {
  //   getWhatsAppNumber();
  // }, []);

  // useEffect(() => {
  //   const chkLog = window.setInterval(function () {
  //     if (userInfo) {
  //       checkNewLogin();
  //     }
  //   }, 5000);
  //   return () => {
  //     clearInterval(chkLog)
  //   }
  // }, [])

  const togglePopup = (isClose = null) => {
    if (isClose == "Yes") {
      setShowLoginModel(false);
    } else {
      setShowLoginModel(!showLoginModel);
    }
    setShowForgotModel(false);
    setShowSignupModel(false);
    // setShowMenu(false);
  };

  const toggleForgotPopup = () => {
    setShowLoginModel(false);
    setShowSignupModel(false);
    setShowForgotModel(!showForgotModel);
    // setShowMenu(false);
  };

  const toggleSignUpPopup = () => {
    setShowLoginModel(false);
    setShowForgotModel(false);
    setShowSignupModel(!showSignupModel);
    // setShowMenu(false);
  };

  return (
    <>
      {showLoginModel && <Login onClose={() => setShowLoginModel(false)} />}
      <ForgotPassword
        showForgotPopup={showForgotModel}
        togglePopup={togglePopup}
        toggleForgotPopup={toggleForgotPopup}
        handleClose={handleClose}
      />
      {/* <SignUp
        showSignupPopup={showSignupModel}
        togglePopup={togglePopup}
        whatsappNum={whatsappNum}
        openWhatsApp={openWhatsApp}
        toggleSignUpPopup={toggleSignUpPopup}
        handleClose={handleClose}
      /> */}

      {isMobile ? (
        <div className="reference-mobile-header-stack">
          {/* Row 1: Logo, balance and account */}
          <header className="reference-mobile-header">
            <div className="reference-header-brand">
              {/* <button
                type="button"
                className="reference-hamburger"
                onClick={handleToggleMenu}
                aria-label="Open navigation menu"
              >
                <span />
                <span />
                <span />
              </button> */}

              <button
                type="button"
                className="reference-hamburger"
                onClick={openSideMenu}
                aria-label="Open navigation menu"
                aria-expanded={showMenu}
              >
                <i className="fas fa-bars" aria-hidden="true" />
              </button>

              <Link to="/" className="reference-logo-link">
                <img
                  src="/Images/logo.png"
                  alt="BMW EXCH"
                  className="reference-mobile-logo"
                />
              </Link>
            </div>

            {userInfo ? (
              <div className="reference-account-area" ref={accountMenuRef}>
                <button
                  type="button"
                  className="reference-account-summary"
                  onClick={toggleAccountMenu}
                  aria-haspopup="menu"
                  aria-expanded={showAccountMenu}
                >
                  {showHeaderBalance && (
                    <span className="reference-balance">
                      Balance:
                      <strong>{Number(balanceWithExp || 0).toFixed(0)}</strong>
                    </span>
                  )}

                  <span className="reference-account-bottom">
                    {showHeaderExposure && (
                      <span
                        className="reference-exposure reference-exposure-clickable"
                        role="button"
                        tabIndex={0}
                        title="View My Market"
                        onClick={openMyMarketsPopup}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            openMyMarketsPopup(event);
                          }
                        }}
                      >
                        Exp:
                        <strong>{Number(exposure || 0).toFixed(0)}</strong>
                      </span>
                    )}

                    <span className="reference-username">
                      {userInfo?.user_name || "User"}
                    </span>

                    <i
                      className={[
                        "fas",
                        "fa-chevron-down",
                        "ms-1",
                        "reference-account-chevron",
                        showAccountMenu ? "reference-account-chevron-open" : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      aria-hidden="true"
                    />
                  </span>
                </button>

                {showAccountMenu && (
                  <div className="reference-account-dropdown" role="menu">
                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() => openAccountPage("/account-statement")}
                      role="menuitem"
                    >
                      Account Statement
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() => openAccountPage("/deposit")}
                      role="menuitem"
                    >
                      Deposit
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() => openAccountPage("/withdraw")}
                      role="menuitem"
                    >
                      Withdraw
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() => openAccountPage("/openbets")}
                      role="menuitem"
                    >
                      Current Bet
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() => openAccountPage("/casino-results")}
                      role="menuitem"
                    >
                      Casino Results
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={() => openAccountPage("/set-button-values")}
                      role="menuitem"
                    >
                      Set Button Values
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item"
                      onClick={openRulesModal}
                      role="menuitem"
                      aria-haspopup="dialog"
                    >
                      Rules
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item reference-account-toggle"
                      onClick={toggleHeaderBalance}
                      role="menuitemcheckbox"
                      aria-checked={showHeaderBalance}
                    >
                      <span>Balance</span>

                      <span
                        className={[
                          "reference-account-check",
                          showHeaderBalance
                            ? "reference-account-check-active"
                            : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        aria-hidden="true"
                      >
                        {showHeaderBalance && <i className="fas fa-check" />}
                      </span>
                    </button>

                    <button
                      type="button"
                      className="reference-account-menu-item reference-account-toggle"
                      onClick={toggleHeaderExposure}
                      role="menuitemcheckbox"
                      aria-checked={showHeaderExposure}
                    >
                      <span>Exposure</span>

                      <span
                        className={[
                          "reference-account-check",
                          showHeaderExposure
                            ? "reference-account-check-active"
                            : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        aria-hidden="true"
                      >
                        {showHeaderExposure && <i className="fas fa-check" />}
                      </span>
                    </button>

                    <div className="reference-account-divider" />

                    <button
                      type="button"
                      className="reference-account-menu-item reference-signout-item"
                      onClick={handleLogout}
                      role="menuitem"
                    >
                      SignOut
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="reference-mobile-guest-actions">
                <button
                  type="button"
                  className="reference-mobile-search-button"
                  aria-label="Search events"
                >
                  <i className="fas fa-search" aria-hidden="true" />
                </button>

                <button
                  type="button"
                  className="reference-mobile-login-button"
                  onClick={() => setShowLoginModel(true)}
                >
                  Login
                </button>

                <button
                  type="button"
                  className="reference-mobile-register-button"
                  onClick={() => navigate("/signup")}
                >
                  Register
                </button>
              </div>
            )}
          </header>

          {/* Row 2: News */}
          <section className="reference-news-ticker" aria-label="Latest news">
            <div className="reference-news-icon">
              {/* Search icon */}
              <i className="fas fa-search-plus" />
            </div>

            <div className="reference-news-window">
              <div className="reference-news-track">
                <span>Newly Launched Matka Market In Our Exchange</span>

                <span aria-hidden="true">
                  Newly Launched Matka Market In Our Exchange
                </span>
              </div>
            </div>
          </section>

          {/* Row 3: Only live matches */}
          {/* Row 3: Live-match section always visible */}
          {/* {showLiveMatches && (
            <section className="header-live-matches" aria-label="Live matches">
              <div className="header-live-track">
                {headerLiveMatches.length > 0 ? (
                  headerLiveMatches.map((match, index) => {
                    const matchId = getHeaderMatchId(match);

                    const matchName = getHeaderMatchName(match);

                    return (
                      <button
                        key={matchId || `${match.tickerSport}-${index}`}
                        type="button"
                        className={[
                          "header-live-match",
                          `header-live-${match.tickerSport}`,
                        ].join(" ")}
                        onClick={() => openHeaderLiveMatch(match)}
                        title={matchName}
                      >
                        <span className="header-live-blinking-content">
                          <span
                            className="header-live-sport-icon"
                            aria-hidden="true"
                          >
                            {match.tickerSport === "cricket" ? (
                              <i className="d-icon icon-4" />
                            ) : match.tickerSport === "tennis" ? (
                              <i className="d-icon icon-2" />
                            ) : (
                              <i className="d-icon icon-1" />
                            )}
                          </span>

                          <span className="header-live-name">{matchName}</span>
                        </span>
                      </button>
                    );
                  })
                ) : (
                  <div className="header-live-empty">
                    Live matches will appear here
                  </div>
                )}
              </div>
            </section>
          )} */}
        </div>
      ) : (
        <div className="reference-desktop-header-stack">
          <section
            className="reference-desktop-guest-newsbar"
            aria-label="Latest news"
          >
            {userInfo && (
              <>
                <div className="reference-desktop-guest-news-window">
                  <div className="reference-desktop-guest-news-track">
                    <span>
                      🕯 CRICKET FANTASY11 IS NOW AVAILABLE IN OUR EXCHANGE 🏆
                      DREAM BIG WIN BIG 🏆
                    </span>

                    <span aria-hidden="true">
                      🕯 CRICKET FANTASY11 IS NOW AVAILABLE IN OUR EXCHANGE 🏆
                      DREAM BIG WIN BIG 🏆
                    </span>
                  </div>
                </div>
              </>
            )}
          </section>
          <header
            className={
              userInfo
                ? "reference-desktop-header reference-desktop-auth-header"
                : "reference-desktop-header reference-desktop-guest-header"
            }
          >
            <Link to="/" className="reference-desktop-logo-link">
              <img
                src="/Images/logo.png"
                alt="BMW EXCH"
                className="reference-desktop-logo"
              />
            </Link>

            {userInfo ? (
              <div className="reference-desktop-header-right">
                <button
                  type="button"
                  className="reference-desktop-deposit-button"
                  onClick={() => openAccountPage("/deposit")}
                >
                  <svg
                    className="reference-header-action-icon"
                    width="30"
                    height="25"
                    viewBox="0 0 64 64"
                    aria-hidden="true"
                  >
                    <circle fill="#ffffff" cx="32" cy="14" r="3" />
                    <path
                      fill="#ffffff"
                      d="M4,25h56c1.794,0,3.368-1.194,3.852-2.922c0.484-1.728-0.242-3.566-1.775-4.497l-28-17C33.438,0.193,32.719,0,32,0s-1.438,0.193-2.076,0.581l-28,17c-1.533,0.931-2.26,2.77-1.775,4.497C0.632,23.806,2.206,25,4,25z M32,9c2.762,0,5,2.238,5,5s-2.238,5-5,5s-5-2.238-5-5S29.238,9,32,9z"
                    />
                    <rect fill="#ffffff" x="34" y="27" width="8" height="25" />
                    <rect fill="#ffffff" x="46" y="27" width="8" height="25" />
                    <rect fill="#ffffff" x="22" y="27" width="8" height="25" />
                    <rect fill="#ffffff" x="10" y="27" width="8" height="25" />
                    <path
                      fill="#ffffff"
                      d="M4,58h56c0-2.209-1.791-4-4-4H8C5.791,54,4,55.791,4,58z"
                    />
                    <path
                      fill="#ffffff"
                      d="M63.445,60H0.555C0.211,60.591,0,61.268,0,62v2h64v-2C64,61.268,63.789,60.591,63.445,60z"
                    />
                  </svg>
                  <span>Deposit</span>
                </button>

                <button
                  type="button"
                  className="reference-desktop-withdraw-button"
                  onClick={() => openAccountPage("/withdraw")}
                >
                  <svg
                    className="reference-header-action-icon"
                    width="30"
                    height="25"
                    viewBox="0 -5.5 37 37"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                  >
                    <title>withdrawal</title>

                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        transform="translate(-2161.000000, -547.000000)"
                        fill="#fff"
                        fillRule="nonzero"
                      >
                        <g transform="translate(1350.000000, 120.000000)">
                          <path
                            d="M833.95742,449.325161 L833.979486,449.298794 C834.583166,449.83056 835.334085,450.197377 836.162706,450.3293 L836.413553,450.36176 L836.412987,452.999942 C834.868195,452.903984 833.459525,452.302114 832.348743,451.35704 L832.130606,451.163498 L833.95742,449.325161 L833.979486,449.298794 Z M839.839189,449.189238 L841.621348,450.98129 C841.645806,451.005617 841.670343,451.025142 841.697469,451.04088 C840.608384,452.100762 839.176833,452.806805 837.585967,452.974794 L837.285857,452.999942 L837.285291,450.36176 C838.269854,450.263422 839.15802,449.835501 839.839189,449.189238 Z M832.488859,446.438341 L832.512709,446.436239 C832.585523,447.177501 832.841921,447.864498 833.23554,448.450598 L833.389489,448.665565 L833.341103,448.705254 L831.526619,450.530714 C830.647811,449.487249 830.06684,448.181949 829.915733,446.74761 L829.88998,446.438325 L832.488859,446.438341 L832.512709,446.436239 Z M841.186135,446.436239 L841.209985,446.438341 L843.808864,446.438325 C843.723095,447.837318 843.229574,449.125341 842.446367,450.183642 L842.274146,450.406861 L842.237666,450.361383 L840.412117,448.525146 C840.834685,447.923089 841.110211,447.209163 841.186135,446.436239 Z M836.849422,442.493272 C838.774918,442.493272 840.335841,444.063287 840.335841,446 C840.335841,447.936713 838.774918,449.506728 836.849422,449.506728 C834.923926,449.506728 833.363003,447.936713 833.363003,446 C833.363003,444.063287 834.923926,442.493272 836.849422,442.493272 Z M840.2697,427 C841.739265,427 842.930582,428.2042 842.930582,429.689655 L842.93,430.538 L838.095778,430.538718 L838.095579,430.256336 C838.095579,429.266032 837.301368,428.463232 836.321658,428.463232 C835.979971,428.463232 835.645555,428.56298 835.358607,428.750486 L829.22855,432.756148 C828.405789,433.293778 828.169982,434.403805 828.701861,435.235463 C828.838171,435.448602 829.017691,435.630063 829.22855,435.767848 L833.456223,438.530833 C830.692171,439.78428 828.768189,442.57994 828.768189,445.827586 C828.768189,446.771503 828.930718,447.677238 829.229164,448.518023 L813.660882,448.517241 C812.191317,448.517241 811,447.313042 811,445.827586 L811,429.689655 C811,428.2042 812.191317,427 813.660882,427 L840.2697,427 Z M831.526113,441.469887 L833.341103,443.294746 L833.389489,443.334435 C832.962301,443.894567 832.666531,444.561419 832.548539,445.288363 L832.512716,445.563692 L832.488859,445.561659 L829.889991,445.5615 C829.985391,444.006031 830.584859,442.587751 831.526113,441.469887 Z M840.237727,443.243044 L842.093019,441.376873 C843.014281,442.433138 843.625109,443.770129 843.78219,445.243698 L843.808853,445.5615 L841.209985,445.561659 L841.186128,445.563692 C841.108793,444.776519 840.824426,444.050543 840.388553,443.44161 L840.237727,443.243044 L842.093019,441.376873 Z M820.421736,442.241379 L815.375429,442.241379 C814.918365,442.241379 814.547842,442.611902 814.547842,443.068966 C814.547842,443.49087 814.863554,443.839036 815.271618,443.890104 L815.375429,443.896552 L820.421736,443.896552 C820.8788,443.896552 821.249323,443.526029 821.249323,443.068966 C821.249323,442.611902 820.8788,442.241379 820.421736,442.241379 Z M828.010177,442.241379 L822.963869,442.241379 C822.506806,442.241379 822.136283,442.611902 822.136283,443.068966 C822.136283,443.49087 822.451995,443.839036 822.860059,443.890104 L822.963869,443.896552 L828.010177,443.896552 C828.46724,443.896552 828.837763,443.526029 828.837763,443.068966 C828.837763,442.611902 828.46724,442.241379 828.010177,442.241379 Z M836.412987,439.000058 L836.413917,441.628808 L836.415573,441.638038 C835.486963,441.73035 834.644015,442.115839 833.982047,442.701719 L833.970063,442.688086 L833.95742,442.674839 L832.129611,440.837423 C833.27144,439.780778 834.76473,439.102443 836.412987,439.000058 Z M837.285224,441.619128 L837.285857,439.000058 C838.784012,439.093119 840.15414,439.662006 841.248688,440.558307 L841.478962,440.755329 L839.624735,442.620211 C839.040521,442.134328 838.32822,441.798742 837.54638,441.672343 L837.283271,441.638038 L837.285224,441.619128 L837.285857,439.000058 Z M838.290746,437.983187 L842.931,437.984 L842.931367,440.827973 C841.785388,439.389903 840.155844,438.358489 838.290746,437.983187 Z M836.32143,430.256336 L836.322891,432.331765 L848,432.33214 L848,436.191856 L836.322891,436.191415 L836.32143,438.26766 L830.191373,434.261998 L836.32143,430.256336 Z M818.982646,430.586207 C818.452535,430.586207 817.976735,430.821249 817.651675,431.193857 C817.327674,430.821249 816.851874,430.586207 816.321764,430.586207 C815.342054,430.586207 814.547842,431.389007 814.547842,432.37931 C814.547842,433.369614 815.342054,434.172414 816.321764,434.172414 C816.851874,434.172414 817.327674,433.937372 817.652734,433.564763 C817.976735,433.937372 818.452535,434.172414 818.982646,434.172414 C819.962355,434.172414 820.756567,431.389007 820.756567,432.37931 C820.756567,433.369614 819.962355,434.172414 818.982646,434.172414 Z"
                            id="withdrawal"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span>Withdraw</span>
                </button>

                <button
                  type="button"
                  className="reference-desktop-rules-button"
                  onClick={openRulesModal}
                  aria-haspopup="dialog"
                  aria-expanded={showRulesModal}
                >
                  Rules
                </button>

                <label className="reference-desktop-auth-search">
                  <i className="fas fa-search" aria-hidden="true" />
                  <input
                    type="search"
                    placeholder="Search Events"
                    aria-label="Search Events"
                  />
                </label>

                <div className="reference-desktop-totals">
                  {showHeaderBalance && (
                    <span>
                      Bal:
                      <strong>{Number(balanceWithExp || 0).toFixed(0)}</strong>
                    </span>
                  )}

                  {showHeaderExposure && (
                    <span
                      className="reference-exposure reference-exposure-clickable"
                      role="button"
                      tabIndex={0}
                      title="View My Market"
                      onClick={openMyMarketsPopup}
                      onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                          openMyMarketsPopup(event);
                        }
                      }}
                    >
                      Exp:
                      <strong>{Number(exposure || 0).toFixed(0)}</strong>
                    </span>
                  )}
                </div>

                <div
                  className="reference-desktop-user-area"
                  ref={accountMenuRef}
                >
                  <button
                    type="button"
                    className="reference-desktop-user-button"
                    onClick={toggleAccountMenu}
                    aria-haspopup="menu"
                    aria-expanded={showAccountMenu}
                  >
                    <span className="reference-desktop-username">
                      {userInfo?.user_name || "User"}
                    </span>

                    <i
                      className={[
                        "fas",
                        "fa-chevron-down",
                        "reference-desktop-chevron",
                        showAccountMenu ? "reference-desktop-chevron-open" : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      aria-hidden="true"
                    />
                  </button>

                  {showAccountMenu && (
                    <div
                      className="reference-account-dropdown reference-desktop-account-dropdown"
                      role="menu"
                    >
                      <div className="account-popup-summary">
                        <div>
                          <span>
                            Wallet Amount <small>(Inclusive bonus)</small>
                          </span>
                          <strong>
                            {Number(balanceWithExp || 0).toFixed(2)}
                          </strong>
                        </div>

                        <div>
                          <span>Net Exposure</span>
                          <strong>{Number(exposure || 0).toFixed(2)}</strong>
                        </div>

                        <div>
                          <span>Bonus</span>
                          <strong>0.00</strong>
                        </div>

                        <div>
                          <span>
                            Available
                            <br />
                            Withdrawal
                          </span>
                          <strong>
                            {Number(balanceWithExp || 0).toFixed(2)}
                          </strong>
                        </div>
                      </div>

                      <div className="account-popup-promo">
                        <button
                          type="button"
                          onClick={() => openAccountPage("/referandearn")}
                        >
                          Refer and Earn
                        </button>

                        <button type="button">Awaiting Bonus 1290</button>
                      </div>

                      <div className="account-popup-links">
                        <button
                          type="button"
                          onClick={() => openAccountPage("/openbets")}
                        >
                          My Bets
                        </button>

                        <button
                          type="button"
                          onClick={() => openAccountPage("/account-statement")}
                        >
                          Account Statement
                        </button>

                        <button
                          type="button"
                          onClick={() => openAccountPage("/mymarkets")}
                        >
                          Market Analysis
                        </button>

                        <button
                          type="button"
                          onClick={() => openAccountPage("/settings")}
                        >
                          Stake Settings
                        </button>

                        <button
                          type="button"
                          onClick={() => openAccountPage("/changepassword")}
                        >
                          Change Password
                        </button>

                        <button
                          type="button"
                          onClick={() => openAccountPage("/rules")}
                        >
                          Bonus Rules
                        </button>
                      </div>

                      <button
                        type="button"
                        className="account-popup-logout"
                        onClick={handleLogout}
                      >
                        <span>LOGOUT</span>
                        <i className="fas fa-sign-out-alt" aria-hidden="true" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="reference-desktop-guest-actions">
                <button
                  type="button"
                  className="reference-desktop-guest-rules"
                  onClick={openRulesModal}
                >
                  Rules
                </button>

                <label className="reference-desktop-guest-search">
                  <i className="fas fa-search" aria-hidden="true" />
                  <input
                    type="search"
                    placeholder="Search Events"
                    aria-label="Search Events"
                  />
                </label>

                <button
                  type="button"
                  className="reference-desktop-guest-login"
                  onClick={() => setShowLoginModel(true)}
                >
                  Login
                </button>

                <button
                  type="button"
                  className="reference-desktop-guest-register"
                  onClick={() => navigate("/signup")}
                >
                  Register
                </button>
              </div>
            )}
          </header>

          {showDesktopNavigation && (
            <nav
              className={
                userInfo
                  ? "reference-desktop-primary-nav reference-desktop-auth-primary-nav"
                  : "reference-desktop-primary-nav reference-desktop-guest-primary-nav"
              }
              aria-label="Primary navigation"
            >
              <div className="reference-desktop-primary-track">
                {DESKTOP_NAV_ITEMS.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className={[
                      "reference-desktop-primary-item",
                      item.id === "fantasy-11"
                        ? "reference-desktop-fantasy-item"
                        : "",
                      ["casino", "sports-book"].includes(item.id)
                        ? "reference-desktop-highlight-nav-item"
                        : "",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                    onClick={() => openDesktopNavigation(item)}
                  >
                    {item.crash && (
                      <img
                        src={`${process.env.PUBLIC_URL}/Images/crash-plane.svg`}
                        alt=""
                        className="reference-desktop-crash-plane"
                        aria-hidden="true"
                      />
                    )}

                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            </nav>
          )}
          {/* Desktop live matches */}
          {/* {showLiveMatches && (
            <section
              className="desktop-header-live-matches"
              aria-label="Live matches"
            >
              <div className="desktop-header-live-track">
                {headerLiveMatches.length > 0 ? (
                  headerLiveMatches.map((match, index) => {
                    const matchId = getHeaderMatchId(match);
                    const matchName = getHeaderMatchName(match);

                    return (
                      <button
                        key={matchId || `${match.tickerSport}-${index}`}
                        type="button"
                        className={[
                          "desktop-header-live-match",
                          `desktop-header-live-${match.tickerSport}`,
                        ].join(" ")}
                        onClick={() => openHeaderLiveMatch(match)}
                        title={matchName}
                      >
                        <span className="desktop-header-live-blink">
                          <span
                            className="desktop-header-live-icon"
                            aria-hidden="true"
                          >
                            {match.tickerSport === "cricket" ? (
                              <i className="d-icon icon-4" />
                            ) : match.tickerSport === "tennis" ? (
                              <i className="d-icon icon-2" />
                            ) : (
                              <i className="d-icon icon-1" />
                            )}
                          </span>

                          <span className="desktop-header-live-name">
                            {matchName}
                          </span>
                        </span>
                      </button>
                    );
                  })
                ) : (
                  <div className="desktop-header-live-empty">
                    Live matches will appear here
                  </div>
                )}
              </div>
            </section>
          )} */}
        </div>
      )}

      {/* Offcanvas menu for mobile (Left Slider) */}
      {/* <Offcanvas show={showMenu} onHide={handleToggleMenu} placement="start"> */}
      {/* <Offcanvas
        show={showMenu}
        onHide={isMobile ? handleToggleMenu : undefined}
        placement="start"
        backdrop={isMobile}
        scroll={!isMobile}
        className={isMobile ? "" : "desktop-sidebar"}
        style={isMobile ? {} : { width: 250, position: 'fixed', top: 56, height: '100vh', zIndex: 1040 }}
      >
        <Offcanvas.Header closeButton>
        <Offcanvas.Header closeButton={isMobile}>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item active">
                <button className="nav-link" onClick={() => navigate('/openbets')}><FaRegEye size={30} color="black" style={{ marginRight: 10 }} />My markets</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleAviator}><FaRocket size={30} color="Orange" style={{ marginRight: 10 }} />Aviator</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/cricketlist')}><BiCricketBall size={30} color="#900C3F" style={{ marginRight: 10 }} />Cricket</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/football-list')}><BiFootball size={30} color="black" style={{ marginRight: 10 }} />Football</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/tennislist')}><BiSolidTennisBall size={30} color="green" style={{ marginRight: 10 }} />Tennis</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleHorseRacingList}><FaHorseHead size={30} color="black" style={{ marginRight: 10 }} />Horce Racing</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleGrayHoundRacingList}><FaHorse size={30} color="brown" style={{ marginRight: 10 }} />Grayhound Racing</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => CreateAndLaunchWCOCasino('EZ', '', '')}><ImSpades size={30} color="black" style={{ marginRight: 10 }} />Indian Card Games</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleIndianCardGamesList}><FaTrophy size={30} color="#ffd133" style={{ marginRight: 10 }} />Sportsbook (80+)</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/ezugiLobby')}><PiMonitorPlay size={30} color="black" style={{ marginRight: 10 }} />Casino</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={() => navigate('/ezugiLobby', { state: { activeCasino: 'Spribe' } })}><FaDice size={30} color="red" style={{ marginRight: 10 }} />Slot Games</button>
              </li>
            </ul>
          </Nav>
          {showLoginPopup && <LoginPopup onClose={handleLoginPopupClose} />}
        </Offcanvas.Body>
      </Offcanvas> */}

      {/* Fullscreen Offcanvas for Account Status (Right Slider) */}
      {/* <Offcanvas
        show={showOffcanvas}
        onHide={handleClose}
        placement="end"
        className="offcanvas-fullscreen"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Account Status</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AccountStatus
            handleLogout={handleLogout}
            handleClose={handleClose}
            userInfo={userInfo}
          />
        </Offcanvas.Body>
      </Offcanvas> */}

      {/* <RightMenu /> */}
      {showOffcanvas && (
        <RightMenu
          open={showOffcanvas}
          onClose={() => setShowOffcanvas(false)}
          email={userInfo?.email || userInfo?.user_name || "User"}
          balance={balance}
          whatsappNum={whatsappNum}
          freeCash={balanceWithExp}
          netExposure={exposure}
        />
      )}

      {/* Sidebar Menu */}
      {/* {(showMenu || !isMobile) && (
        <SideMenu />
      )} */}

      <MyMarketPopup
        open={showMyMarkets}
        onClose={closeMyMarketsPopup}
        rows={myMarketRows}
        loading={myMarketLoading}
        onSelectMarket={handleSelectMyMarket}
      />

      <RulesModal open={showRulesModal} onClose={closeRulesModal} />
    </>
  );
};

export default Header;
